import React from "react";

class LOLout extends React.Component {
    render() {
      const styles={
        blackbg: {
          backgroundColor: "#121212"
        },
        blueText:{
          color: "#037ef3"
        }
      }

      return <div className="w-full h-full text-white" style={styles.blackbg}>
            <div className="w-full max-w-2xl m-auto py-8 px-4">
                <div className="text-xl" style={styles.blueText}>AIESEC in SLIIT</div>
                <div className="text-4xl font-bold">oGT B2C - Leadership Body - Round 2</div>
                <div className="text-xl mt-1 text-gray-400">Application Package</div>

                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-1 font-semibold">Timeline</div>
                  <div>
                    <span className="font-bold">Application Open - </span> <span className="text-gray-300">25th June</span> <br/>
                    <span className="font-bold">Application Deadline - </span> <span className="text-gray-300">27th June 11:59 PM</span> <br/>
                  </div>
                </div>

                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-1 font-semibold">Team Structure</div>
                  <div>
                    <span className="font-bold">Members</span> <span className="text-gray-400"> x18</span> <br/>
                    <span className="font-bold">Team Leaders</span> <span className="text-gray-400">x4</span> <br/>
                    <span className="font-bold">2 Team Leaders with 3 members each</span>  <br/>
                    <span className="font-bold">2 Team Leaders with 4 members each</span>  <br/>
                  </div>
                </div>

                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-1 font-semibold">Available Roles</div>
                  <br/>

                  
                  {/*  =====================================================  */}
                  <div className="w-full rounded-lg border p-2" style={{"border": "2px solid #0373f3" }}>
                    <div className="text-center text-2xl font-bold" style={{"color": "#0373f3" }}>Team Leader</div>

                    <div className="font-bold">Job Description</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Responsible for initiation and execution of oGTa and oGTe offline promotions, research and analysis for the markets allocated</li>
                        <li>Responsible for managing LEADs and allocating members for LEAD management.</li>
                        <li>Downscaling the strategies/action plans communicated by the LCVP/OEVP.</li>
                        <li>Responsible for handling external entities and ensure that sufficient sign-ups are received to follow up</li>
                        <li>Responsible for raising B2B partnerships and signing MoUs</li>
                        <li>Maintaining real-time trackers as advised by the LCVP/OEVP</li>
                        <li>Organizing events for online and offline promotions</li>
                        <li>Maintaining member delegation and engagement</li>
                        <li>Accountability towards team performance</li>
                      </ul>
                    </div> <br/>

                    <div className="font-bold">KPIs</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li># of SUs</li>
                        <li># of APP</li>
                        <li># of B2B Partnerships raised</li>
                        <li># of Offline Promotions</li>
                        <li># of Online Campaigns</li>
                        <li># of events</li>
                        <li># of Team meetings held</li>
                      </ul>
                    </div>
                  </div>
                  <br />

                 

                {/** Contact Info ***/}
                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-4 font-semibold">Contact Info</div>
                  <div>
                    <div >For any clarifications, </div> 
                    <div style={styles.blueText} className="text-3xl">Tharani Medawatte</div> 
                    <div className="text-gray-400">OEVP oGT B2C – AIESEC in SLIIT</div>
                    <div className="text-gray-400">tharani.medawatte2@aiesec.net</div>
                    <div className="text-gray-400">+94 77 880 7759</div>
                    
                  </div>
                </div>

                

                <a href="https://docs.google.com/forms/d/e/1FAIpQLSd5ERlbXwXpSqa5IUP6H4FfKS_dXvje43i-WOQnQgj7OnBKPw/viewform?usp=sf_link" target="_blank" rel="noreferrer">
                <div className="my-8 rounded-md w-full h-10 text-center text-lg font-bold grid content-center cursor-pointer" style={{"background": "#037ef3"}}>
                  Apply
                </div>
                </a>

                </div>
            </div>
      </div>;
    }
  }

export default LOLout